import React, { useState, useEffect, useRef } from "react";
import { currencyFormatter } from "../utils";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { UrlPath } from "../../../config/routeConfig";
import { TopBar } from "../../shared/topBar/TopBar";
import { useNavigate, useParams, useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { SBADropDown, SBAComboBox } from "../../UiComponents/SBADropDown";
import { getPortFolioListAction, getPortFolioCashAction, getPortFolioCashAccountAction } from "../../actions/portfolioAction";
import { getTransactionStatusAction } from "../../actions/transactionAction";
import { getAssetCurrencyType } from "../../actions/assetAction";
import { sbaAxios } from "../../utils/sbaAxios";
import { insertUpdateTransactionAPI, getUserPageAccess, insertAssetLots, getPortfolioListAPI, getPortfolioCashAccounts, getTransactionAssetsByType, assetDetailsUrl, insertUpdateSubscriptionAPI, transactionSaveCapitalCallAndSubAPI, CheckIfAllocationExistsAPI } from "../../../config/apiConfig";
import { SBDatePicker } from "../../UiComponents/SBDatePicker";
import { SBNotify } from "../../utils/sbNotify";
import { ToastContainer } from "react-toastify";
import moment from "moment";
import { getPortfolioDetailAPI, getAssetLotByPortfolio, getPortfolioExistingAsset, getAssetShareClassddl } from "../../../config/apiConfig";
import { getTransactionByID,getPortfolioListByAssetAndTransType,gettransactionEditAccess } from "../utils";
import { Modal } from "react-bootstrap";
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { getAsset } from "../../actions/assetAction";
import { SBACurrencyInput } from "../../UiComponents/SBACurrencyInput";
import { Link } from "react-router-dom";
import { ExchangeRateModal } from "../Components/ExchangeRateModal";
const date = new Date();
const transactionDate = new Date(date.getFullYear(), date.getMonth() + 1, 1);

export const Allocation = () => {
  const transactionDetails = {
    "TransId": 0,
    "TransTypeId": 3,
    "TransTypeName": "Allocate",
    "PortfolioId": 0,
    "PortfolioName": "",
    "AssetId": 0,
    "AssetName": "",
    "ShareclassId": 0,
    "ShareClassName": "",
    "AssetLotId": 0,
    "AccountIdToBalance": 0,
    "AccountIdToBalanceName": "",
    "InitialAllocationDate": transactionDate,
    "AssetLotName": "",
    "TradeStatusId": 2,
    "TradeStatusName": "Executed",
    "TransDate": transactionDate,
    "TransAmount": null,
    "LocalAmount": null,
    "Shares": 0,
    "NAV": 0,
    "NrOfShares": 0,
    "CurrencyId": 0,
    "CurrencyCode": "",
    "ExchangeRateId": 0,
    "ExchangeRate": 1.00,
    "IsFullRedemption": false,
    "IsInsurance": false,
    "IsFee": false,
    "IsCommitmentRelease": false,
    "TransDescription": "",
    "ModifiedById": 0,
    "ModifiedByName": "",
    "IsShareBased": false,
    "ChildDetails": [
      {
        "TransId": 0,
        "TransTypeId": 22,
        "TransTypeName": "Load/Fee",
        "AssetId": 1,
        "AssetName": "CASH",
        "ShareclassId": 0,
        "ShareClassName": "",
        "AssetLotId": 0,
        "AssetLotName": "",
        "TransDate": transactionDate,
        "TransAmount": 0,
        "TransDescription": "",
        "ModifiedById": 0,
        "ModifiedByName": ""
      }
    ]
  
  };

  const history = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();

  const Gstate = useSelector((state) => state);
  const FromAccount = Gstate.portfolio.TOCash || [];
  const StatusStore = Gstate.transaction.statusList || [];


  const transactionId = parseInt(params.TransId) || 0;
  const objType = parseInt(params?.ObjectType);



  const Level = objType == 1 ? [
    {
      BreadCrumb: "Transactions >",
      Routes: `${UrlPath.Transactions}${params.EntityId}`,
    },
    {
      BreadCrumb: "Subscription",
      Routes: `${UrlPath.Allocation}${params.EntityId}`,
    },
  ] : [
    {
      BreadCrumb: "Transactions >",
      Routes: `/${UrlPath.portfolioTransaction}${params.EntityId}`,
    },
    {
      BreadCrumb: "Subscription",
      Routes: `/${UrlPath.PortfolioAllocation}${params.EntityId}`,
    },
  ];

  // data States
  const [transactionData, setTransactionData] = useState(transactionDetails);
  const [portfolio, setPortfolio] = useState({});
  const [asset, setAsset] = useState({});
  const [portfolioList, setPortfolioList] = useState([]);
  const [assetList, setAssetList] = useState([]);
  const [shareClassList, setShareClassList] = useState([]);
  const [assetLots, setAssetLots] = useState([]);

  const [isShareBased, setIsShareBased] = useState(assetLots.find(lot => lot.AssetLotId === transactionData.AssetLotId)?.IsShareBased || false);

  const [fromAccountDS,setFromAccountDs]=useState([]);

  // Components State
  const [createLot, setCreateLot] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const[transactionEditAccess,setTransactionEditAccess]=useState(false);

  // page datas;
  const assetValue = { AssetId: transactionData.AssetId, AssetName: transactionData.AssetName };
  const portfolioValue = { PortfolioId: transactionData.PortfolioId, PortfolioName: transactionData.PortfolioName };
  const fromAccountValue = { AssetId: transactionData.AccountIdToBalance, AssetName: transactionData.AccountIdToBalanceName };
  const statusValue = { TransStatusId: transactionData.TradeStatusId, TransStatus: transactionData.TradeStatusName };
  const shareClassValue = { ShareClassId: transactionData.ShareclassId, ShareClassName: transactionData.ShareClassName };
  const lotValue = { AssetLotId: transactionData.AssetLotId, AssetLotName: transactionData.AssetLotName };
  const lotName =transactionData.AssetLotName ;


  const navValue = transactionData.NAV;
  const sharesCount = transactionData.NrOfShares;
  const transAmt = transactionData.TransAmount;
  const localAmount = transactionData.LocalAmount;
  const exchangeRate = transactionData.ExchangeRate;
  const transDate = transactionData.TransDate;
  const initialAllocationDate = transactionData.TransDate;
  const description = transactionData.TransDescription;
  const loadFee = transactionData?.ChildDetails?.find(item=>item.TransTypeId===22)?.TransAmount || 0;
  const localLoadFee=loadFee*exchangeRate
  const totalTransAmt = transAmt+loadFee;
  const totalLocalAmt= localAmount+localLoadFee;
 
  useEffect(() => {
    document.title = "Transactions Subscription";
    setTransactionEditUserAccess();
    dispatch(getPortFolioCashAccountAction(params?.EntityId));
    dispatch(getTransactionStatusAction());
    // setTransactionByID(transactionId);

    if (objType === 1) {
      // dispatch(getAsset(params?.EntityId));
      setAssetByID(params?.EntityId);
      if(transactionId<0)
      setPortfolioByAssetId(params?.EntityId);
    }
    else if (objType === 3) {
      setPortfolioByID(params?.EntityId);
      // setAssetListByPortfolio(params?.EntityId);
    }
    setTransactionByID(transactionId)
  }, []);
  useEffect(()=>{
    if(transactionData.PortfolioId > 0)
    {
      setAccontByPId(transactionData?.PortfolioId);
    }
  },[transactionData.PortfolioId])
  useEffect(() => {
    if (transactionData.AssetId > 0) {
      setShareClassListbyAssetID(transactionData.AssetId);
    }
  }, [transactionData.AssetId]);
  useEffect(() => {
   if (transactionData.ShareclassId > 0) {
     setLotsByPIdAssetIdSCId(transactionData.PortfolioId, transactionData.AssetId, transactionData.ShareclassId)
   }
  }, [transactionData.ShareclassId]);

   // User Access Rights
   const setTransactionEditUserAccess= async()=>
   {
       const access = await gettransactionEditAccess();
       setTransactionEditAccess(access);
   }

  const getAccountByPId=async(pid)=>{
    try{
      const response=await sbaAxios({url:`${getPortfolioCashAccounts}${pid}`})
      return  response;
    }
    catch{
       return []
    }
   
  };
  const setAccontByPId=async(pid)=>{
    try{
      const accountList=await getAccountByPId(pid);
      setFromAccountDs(accountList);
    }
    catch{
      setFromAccountDs([]);
    }
  }
  const setLotsByPIdAssetIdSCId = async (Id, assetId, shareclassId) => {
    try {
      const lots = await getAssetLotsByID(Id, assetId, shareclassId);
      if (lots.length > 0) {
        setAssetLots(lots);
        setIsShareBased(lots[0]?.IsShareBased)
      }
      else {
        setAssetLots([]);
        setIsShareBased(false);
       // setTransactionData(value => ({ ...value, AssetLotId: 0, AssetLotName: "", IsShareBased: false }))
      }
    }
    catch (e) {
      setAssetLots([]);
      setIsShareBased(false);
      //setTransactionData(value => ({ ...value, AssetLotId: 0, AssetLotName: "" }))
    }

  };
  const getAssetLotsByID = async (Id, assetId, shareclassId) => {
    try {
      const response = await sbaAxios({
        url: `${getAssetLotByPortfolio}${Id},${assetId},${shareclassId}`,
        method: 'get',
      });

      return response;
    }
    catch (e) {
      console.log(e, 'Error Fetching the Asset lots')
      return [];
    };
  };
  const setTransactionByID = async (id) => {
    if (id > 0) {
      try {
        const details = await getTransactionByID(id);
        setTransactionData(details);
        setPortfolioByID(details.PortfolioId);
      } catch (e) {
        setTransactionData(transactionDetails);
      }
    }
    else {
      setTransactionData(transactionDetails);
    }
  };
  const getAssetDetailsByID=async(id)=>{
   try{
    return await sbaAxios({
      url: `${assetDetailsUrl}${id}`,
      method: 'get',
    })

   }
   catch{

   } 
  }
  const CheckAllocationStatus = async (pID, aID, scID, Date,alID) => {
    try {
        const url = `${CheckIfAllocationExistsAPI}${pID},${aID},${scID},${transactionData.TransTypeId},${Date},${alID}`
        const res = await sbaAxios({ url })
        if (res)
            SBNotify({ Msg: "An allocation already exists on the selected date for current portfolio/asset/ShareClass combination", type: 'error' });
    } catch (error) {

    }
}
  const setPortfolioByAssetId = async (Id) => {
      
    try {
      const portfolio = await getPortfolioListByAssetAndTransType(Id,3);
    const  portfolios= portfolio.map((item) => ({
        'PortfolioName':item.Name,
        'PortfolioId':item.PortfolioId
    }))
    setPortfolioList([]);
    if(portfolios.length>0)
    {
      
      setTransactionData(value => ({ ...value, "PortfolioName": portfolios[0]?.PortfolioName, "PortfolioId": portfolios[0]?.PortfolioId }));
      setPortfolioByID(portfolios[0]?.PortfolioId);
    }
    }
    catch (e) {
      setTransactionData(value => ({ ...value, PortfolioId: 0, PortfolioName: '' }));
      setPortfolioList({});
    }
  }

  const updateStatus = (e) => {
    if (e.value) {
      const status = e.value;
      setTransactionData(pv => ({ ...pv, TradeStatusId: status.TransStatusId, TradeStatusName: status.TransStatus }));
    }
  };
  const updateFromAccount = (e) => {
    if (e.value) {
      const fromAccount = e.value;
      setTransactionData(pv => ({ ...pv, AccountIdToBalance: fromAccount.AssetId, AccountIdToBalanceName: fromAccount.AssetName }));
    }
  };
  const updateShareClass = (e) => {
      if (e.value) {
 
        const shareClass = e.value;
        const assetLotName = `${e.value.ShareClassName} - ${moment(transactionData.TransDate).format("MM/DD/yyyy")}`;
        const dateValue = convertToISO(transactionData?.TransDate);
        const assetLotId=transactionData?.AssetLotId || 0;
        CheckAllocationStatus(transactionData.PortfolioId, transactionData.AssetId, shareClass.ShareClassId, dateValue, assetLotId);
        setTransactionData(pv => ({ ...pv, ShareclassId: shareClass.ShareClassId, ShareClassName: shareClass.ShareClassName, AssetLotName: assetLotName }));
    }
  };
  const updateAssetLot = (e) => {
    if (e.value) {
      const lot = e.value;
      setTransactionData(pv => ({ ...pv, AssetLotId: lot.AssetLotId, AssetLotName: lot.AssetLotName }));
    }
  };
  const updatePortfolio = (e) => {
    if (e.value) {
      const portfolio = e.value;
      setPortfolioByID(portfolio.PortfolioId);
      if(objType===3)
      {
     
        setTransactionData(pv => ({ ...pv, PortfolioId: portfolio.PortfolioId, PortfolioName: portfolio.PortfolioName, AssetId: 0, AssetName: "", ShareclassId: 0, ShareClassName: '', AssetLotId: 0, AssetLotName: '' , AccountIdToBalance:0 ,AccountIdToBalanceName:'' }));
        setAssetLots([]);
      }
      else if(objType===1)
      {
      
        setTransactionData(pv => ({ ...pv, PortfolioId: portfolio.PortfolioId, PortfolioName: portfolio.PortfolioName , AccountIdToBalance:0 ,AccountIdToBalanceName:''  }));
        if(transactionData.AssetId && transactionData.PortfolioId && transactionData.ShareclassId)
          setLotsByPIdAssetIdSCId(e.value.PortfolioId,transactionData.AssetId,transactionData.ShareclassId);
        else 
        setAssetLots([]);
      }
      setAccontByPId(portfolio.PortfolioId);
    }
  };
 
  const updateAsset = (e) => {
    if (e.value) {
      const asset = e.value;
      if(objType==1)
      {
        setPortfolioByAssetId(e.value.AssetId);
      }
      setTransactionData(pv => ({ ...pv, AssetId: asset.AssetId, AssetName: asset.AssetName, ShareclassId: 0, ShareClassName: '', AssetLotId: 0, AssetLotName: '' }));
      setAssetLots([]);
    }
  };
  const updateTransDate = (e) => {
    if (e) {
      const value = e.toISOString();
      const assetLotId=transactionData?.AssetLotId || 0;

        CheckAllocationStatus(transactionData.PortfolioId, transactionData.AssetId, transactionData.ShareclassId, e.toISOString(), assetLotId);
        const assetLotName = transactionData.ShareClassName ? `${transactionData.ShareClassName} - ${moment(e).format("MM/DD/yyyy")}` : "";
        setTransactionData((prevData) => ({ ...prevData, TransDate: value, AssetLotName: assetLotName }));
    }
  };
  const updateInitialAllocationDate = (e) => {
    if (e) {
      const value = e.toISOString();
      setTransactionData((prevData) => ({ ...prevData, InitialAllocationDate: value }));
    }
  };
 
  const updatedescription = (e) => {
    const updatedValue = e?.target?.value || '';
    setTransactionData(value => ({ ...value, TransDescription: updatedValue }))
    };
  const exchangeRateChange=(e)=>
  {
  const parsedValue = parseFloat(e);
                    setTransactionData(value => ({
                        ...value,
                        ExchangeRate: parsedValue,
                        LocalAmount: Math.abs(value.TransAmount)*parsedValue
                    }));
                  }
    const saveAllocation = () => {
    let saveSuccess = true;
    if (!transactionData.PortfolioId) {
      SBNotify({ Msg: "Please Select Portfolio", type: "error" });
      saveSuccess = false;
      return;
    }
    else if (!transactionData.AssetId) {
      SBNotify({ Msg: "Please Select Asset", type: "error" });
      saveSuccess = false;
      return;

    }
    else if (!transactionData.ChildDetails[0].AssetId) {
      SBNotify({ Msg: "Please Select From Account", type: "error" });
      saveSuccess = false;
      return;

    }
    else if (!transactionData.ShareclassId) {
      SBNotify({ Msg: "Please Select Share Class", type: "error" });
      saveSuccess = false;
      return;

    }
    // else if (!transactionData.AssetLotId) {
    //   SBNotify({ Msg: "Please Create  Lot", type: "error" });
    //   saveSuccess = false;
    //   return;

    // }
    else if (isShareBased && !transactionData.NrOfShares) {
      SBNotify({ Msg: "Please Enter No.of.Shares", type: "error" });
      saveSuccess = false;
      return;

    }
    else if (isShareBased && !transactionData.NAV) {
      SBNotify({ Msg: "Please Enter NAV", type: "error" });
      saveSuccess = false;
      return;

    }

    else if (!transactionData.TransAmount) {
      SBNotify({ Msg: "Please Enter Amount", type: "error" });
      saveSuccess = false;
      return;

    }
    else if (!transactionData.ExchangeRate) {
      SBNotify({ Msg: "Please Enter Exchange Rate", type: "error" });
      saveSuccess = false;
      return;

    }
    else if (!transactionData.InitialAllocationDate)
    {
      SBNotify({ Msg: "Please Select the Initial Allocation Date", type: "error" });
      saveSuccess = false;
      return;

    }

    const loadfeeData=transactionData.ChildDetails.find(item=>item.TransTypeId===22);
    const childTrans = [
      {
        "transId": loadfeeData?.TransId,
        "assetId": loadfeeData?.AssetId,
        "transTypeId":loadfeeData?.TransTypeId,
        "transDate": loadfeeData?.TransDate,
        "transAmount": loadfeeData?.TransAmount || 0,
        "localAmount": (loadfeeData?.TransAmount + transactionData?.TransAmount) * transactionData?.ExchangeRate  ,
        "transDescription": "Fee row",
        "modifiedById": 0
      }
    ];
    
    const apiChildTrans=()=>{
    if(transactionId===0 && loadFee===0) 
    {
      return [];
    } 
    else if(transactionId===0 && loadFee!=0)
    {
      return childTrans
    }
    // else if(transactionId!==0 ) 
    // {
    //   return transactionData.ChildDetails.filter(item=>item.TransTypeId!==22)
    // }
    else 
    {
      const records=transactionData.ChildDetails.map(item=>{if(item.TransTypeId===22){return {...item,LocalAmount:(item?.TransAmount + transactionData?.TransAmount) * transactionData?.ExchangeRate ,ModifiedById: 0 }} else return {...item,ModifiedById: 0}});
      return records;
    }
  }
    const DS = {
      "transId": transactionId,
      "portfolioId": transactionData.PortfolioId,
      "assetId": transactionData.AssetId,
      "shareClassId": transactionData.ShareclassId,
      "assetLotId": transactionData.AssetLotId,
      "accountIdToBalance": transactionData.AccountIdToBalance,
      "tradeStatusId": transactionData.TradeStatusId,
      "transTypeId": 3,
      "transDate": transactionData.TransDate,
      "transAmount": transactionData.TransAmount,
      "localAmount": transactionData.LocalAmount,
      "exchangeRateId": 0,
      "exchangeRate": transactionData.ExchangeRate,
      "initialAllocationDate": transactionData.TransDate,
      "allocationDate": transactionData.TransDate,
      "shares": transactionData.NrOfShares,
      "nav": transactionData.NAV,
      "transDescription": transactionData.TransDescription,
      "isFullRedemption": false,
      "isInsurance": false,
      "isFee": false,
      "isCommitmentRelease": false,
      "modifiedBy": 0,
      "childTrans":apiChildTrans()
    };
   
    if (saveSuccess) {
      sbaAxios({
        url: `${transactionSaveCapitalCallAndSubAPI}`,
        method: "post",
        data: DS,
      })
        .then((response) => {
          if (response) {
            if (response==-1) {
              SBNotify({ Msg: "An allocation already exists on the selected date for current portfolio/asset/ShareClass combination", type: 'error' });
          }
          else{
            setTimeout(() => {
              transactionId !== 0 ? SBNotify({ Msg: 'Subscription Details Updated Successfully' }) : SBNotify({ Msg: 'Subscription Details Added Successfully' });
            }, 500); 
            navigateBack();

          } 
            
          } else {
            SBNotify({
              type: "error",
              Msg: `Failed to Update`,
            });
          }
        })
        .catch(() => { });
    }
  };
//   const SaveSUBLastest = () => {
//     const apiChildTrans=()=>{
//       if(transactionId===0 && loadFee===0) 
//       {
//         return [];
//       } 
//       else if(transactionId===0 && loadFee!=0)
//       {
//         return childTrans
//       }
//       else 
//       {
//         const records=transactionData.ChildDetails.map(item=>{if(item.TransTypeId===22){return {...item,LocalAmount:(item?.TransAmount + transactionData?.TransAmount) * transactionData?.ExchangeRate ,ModifiedById: 0 }} else return {...item,ModifiedById: 0}});
//         return records;
//       }
//     }
//     let saveSuccess = true;  
//     const saveData1 = {
//         "transId": transactionId,
//         "portfolioId": transactionData.PortfolioId,
//         "assetId": transactionData.AssetId,
//         "shareClassId": transactionData.ShareclassId,
//         "assetLotId": transactionData?.AssetLotId || 0,
//         "accountIdToBalance": transactionData.AccountIdToBalance,
//         "tradeStatusId": transactionData.TradeStatusId,
//         "transTypeId": 24,
//         "transDate": transactionData.TransDate,
//         "transAmount": transactionData.TransAmount,
//         "localAmount": transactionData.LocalAmount,
//         "transPercentage": 0, //1
//         "exchangeRateId": 0,
//         "exchangeRate": transactionData.ExchangeRate,
//         "allocationDate": transactionData.InitialAllocationDate,  //1
//         "shares": 0,
//         "nav": 0,
//         "transDescription": transactionData.TransDescription ? transactionData.TransDescription : "",
//         "initialAllocationDate": transactionData.InitialAllocationDate,
//         "isFullRedemption": false,
//         "partialRedemptionModeId": 0, //1
//         "isInsurance": false,
//         "isFee": false,
//         "isShareBased": false, //1
//         "isCommitmentRelease": false,
//         "refTransAssetLotId": 0, //1
//         "modifiedBy": 0,
//         "transactionPEDetails": {
//             "peTransDetailID": 22,  //chnage
//             "isRecallable": false,
//             "isImpactCommitment": transactionData.TransactionPEDetails.IsImpactCommitment,
//             "recallableAmount": 0,
//             "recallablePercent": 0,
//             "interestIncome": transactionData.TransactionPEDetails.InterestIncome,
//             "interestExpense": transactionData.TransactionPEDetails.InterestExpense
//         },
//         "childTrans":apiChildTrans().map(item=>({
//           "transId": item.transId,
//           "assetId": item.assetId,
//           "assetLotId": 0,
//           "transTypeId": item.transTypeId,
//           "transDate": item.transDate,
//           "transAmount": item.transAmount,
//           "localAmount": item.localAmount,
//           "transPercentage": item.transDate,
//           "shares": 0,
//           "transDescription": item.transDescription
//         })),
//       }

//     if (!transactionData.TradeStatusName || transactionData.TradeStatusName === "") {
//         SBNotify({ Msg: "Please Select Status ", type: "error" });
//         saveSuccess = false;
//     }

//     else if (!transactionData.AccountIdToBalance || transactionData.AccountIdToBalance === 0) {
//         SBNotify({ Msg: "From Account is Required", type: "error" });
//         saveSuccess = false;
//     }
//     // else if (!transactionData.AssetLotId || transactionData.AssetLotId === 0) {
//     //     SBNotify({ Msg: "Please Create Lot", type: "error" });
//     //     saveSuccess = false;
//     // }
//     else if (!transactionData.ShareclassId || transactionData.ShareclassId === 0) {
//         SBNotify({ Msg: "Shareclass is Required", type: "error" });
//         saveSuccess = false;
//     }
//     else if (!transactionData.AssetId || transactionData.AssetId === 0) {
//         SBNotify({ Msg: "Asset is Required", type: "error" });
//         saveSuccess = false;
//     }
//     else if (!transactionData.PortfolioId || transactionData.PortfolioId === 0) {
//         SBNotify({ Msg: "Portfolio is Required", type: "error" });
//         saveSuccess = false;
//     }

//     else if (!transactionData.TransDate) {
//         SBNotify({ Msg: "Please Choose Transaction Date", type: "error" });
//         saveSuccess = false;
//     }
//     else if (!transactionData.TransAmount || transactionData.TransAmount === 0) {

//         SBNotify({ Msg: "Please Enter Amount", type: "error" });
//         saveSuccess = false;
//     }

//     if (saveSuccess) {
//         sbaAxios({
//             url: `${transactionSaveCapitalCallAndSubAPI}`,
//             method: "post",
//             data: saveData1,
//         })
//             .then((response) => {
//                 if (response) {
//                     SBNotify({
//                         type: "success",
//                         Msg: "Capital Call Saved Successfully",
//                     });
//                     navigateBack();

//                 } else {
//                     SBNotify({
//                         type: "error",
//                         Msg: `Failed to Update`,
//                     });
//                 }
//             })
//             .catch(() => { });
//     }


// }
  const navigateBack = () => {
    if (objType === 1)
      history(`${UrlPath.Transactions}${transactionData.AssetId}`);
    if (objType === 3)
      history(`/${UrlPath.portfolioTransaction}${transactionData.PortfolioId}`);
  };
  const updateAssetLotAfterInsert = (lotId, list) => {
    const lot = list.find(item => item.AssetLotId == lotId);
    setTransactionData(value => ({ ...value, AssetLotId: lot.AssetLotId, AssetLotName: lot.AssetLotName }))
  }
  const saveAssetLot = (allocationDate, transactionDate, isShareBase) => {
    const LotsDS = {
      "PortfolioId": transactionData.PortfolioId,
      "AssetId": transactionData.AssetId,
      "ShareClassId": transactionData.ShareclassId,
      "IsShareBased": isShareBase,
      "InitAllocationDate": allocationDate,
      "TransactionDate": transactionDate,
    };
    sbaAxios({
      url: `${insertAssetLots}`,
      method: "post",
      data: LotsDS,
    })
      .then(async (response) => {
        if (response) {
          SBNotify({
            type: "success",
            Msg: "Lots Added Successfully",
          });
          const res = await getAssetLotsByID(transactionData.PortfolioId, transactionData.AssetId, transactionData.ShareclassId);
          setCreateLot(false);
          setAssetLots(res)
          updateAssetLotAfterInsert(response, res);

        } else {
          SBNotify({
            type: "error",
            Msg: `Failed to Update`,
          });
        }
      })
      .catch(() => { });
  };
  const openCreatAssetLot = () => {
    if(transactionId===0){
      if (!transactionData.PortfolioId) {
        SBNotify({ Msg: "Please Select Portfolio", type: "error" });
      }
      else if (!transactionData.AssetId) {
        SBNotify({ Msg: "Please Select Asset", type: "error" });
      }
      else if (!transactionData.ShareclassId) {
        SBNotify({ Msg: "Please Select ShareClass", type: "error" });
      }
      else {
        setCreateLot(true)
      }
    }
    
  };
  const portfolioFilterChange = (e) => {
    const terms = e.filter.value;
    if (terms.length > 1) {
      setPortfolioByTerm(terms);
    }
  };
  const AssetFilterChange = (e) => {
    const terms = e.filter.value;
    if (terms.length > 1) {
      setAssetListByTerms(terms);
    }
  };
  const setPortfolioByTerm = async (term) => {
    try {
      const portfolioList = await getPortfolioListByTerms(term);
      setPortfolioList(portfolioList);
    }
    catch (e) {
      console.log(e, 'Error Fetching the data for portfolio');
      setPortfolioList([]);
    }
  };
  const getPortfolioListByTerms = async (term) => {
    try {
      const response = await sbaAxios({ url: getPortfolioListAPI + '?searchText=' + term });
      return response;
    }
    catch (e) {
      return [];
    }
  };
  const setAssetListByTerms = async (term) => {
    try {
      const assetList = await getAssetListByTerm(term);
      setAssetList(assetList);
    }
    catch (e) {
      console.log(e, 'Error Fetching the asset List');
      setAssetList([]);
    }
  }
  const getAssetListByTerm = async (term) => {
    try {
      const resposne = await sbaAxios({ url: `${getTransactionAssetsByType}?transTypeId=3&searchString=${term}` })
      return resposne;
    }
    catch (e) {
      return []
    };
  };
  const setPortfolioByID = async (Id) => {
    try {
      const portfolio = await getPortfolioDetailsByID(Id);
      setTransactionData(value => ({ ...value, PortfolioId: portfolio.PortfolioId, PortfolioName: portfolio.PortfolioName }));
      setPortfolio(portfolio)
    }
    catch (e) {
      setTransactionData((value) => ({ ...value, PortfolioId: 0, PortfolioName: "" }))
    }
  };
  const setAssetByID=async (id)=>{
    try {
      const asset = await getAssetDetailsByID(id);
      setTransactionData(value => ({ ...value, AssetId: asset.AssetId, AssetName: asset.AssetName }));
      setAsset(asset)
    } catch (error) {
      
    }
  };
  const getPortfolioDetailsByID = async (portfolioId) => {
    try {
      const response = await sbaAxios({ url: getPortfolioDetailAPI + portfolioId });
      return response;
    }
    catch (e) {
      console.log(e, 'Error Fetching the portfolio details')
      return {};
    };
  };
  const setShareClassListbyAssetID = async (id) => {
    try {
      const res = await getshareclassbyId(id);
      setShareClassList(res);
    }
    catch (e) {
      setShareClassList([]);
      setTransactionData(value => ({ ...value, ShareclassId: 0, ShareClassName: '' }));
    }
  };
  const getshareclassbyId = async (AssetId) => {
    try {
      const response = await sbaAxios({
        url: `${getAssetShareClassddl}${AssetId},${'true'}`,
        method: 'get',
      });
      return response;
    }
    catch (e) {
      return [];
    };
  };
  const updateShares = (e) => {
    const updatedValue = parseFloat(e) || 0;
    const Amount = navValue * updatedValue;
    const localAmt =  Amount * parseFloat(exchangeRate);
    setTransactionData(pv => ({ ...pv, NrOfShares: updatedValue, TransAmount: Amount, LocalAmount: localAmt }))
  };
  const updateNav = (e) => {
    const updatedValue = parseFloat(e) || 0;
    const Amount = sharesCount * updatedValue;
    const updatedLocalAmt=(Amount) * parseFloat(exchangeRate);
    setTransactionData(pv => ({ ...pv, NAV: updatedValue, TransAmount: Amount, LocalAmount: updatedLocalAmt }))
  };
  const udpateTransAmt = (e) => {
    const updateValue = parseFloat(e) || 0;
    const updatedLocalAmt=(updateValue) * parseFloat(exchangeRate) || 0;
    setTransactionData((prevData) => ({ ...prevData, LocalAmount: (updatedLocalAmt), TransAmount: updateValue }));
  };
  const updateExchangeRate = (e) => {
    const updateValue = parseFloat(e) || 0;
    const updatedLocalAmt=(transAmt) * updateValue || 0;
    setTransactionData((prevData) => ({ ...prevData, LocalAmount: updatedLocalAmt, ExchangeRate: updateValue }));
  };
    const updateLoadFee = (e) => {
    const updateValue = parseFloat(e) || 0 ;
    const updateChildDetails = transactionData.ChildDetails;
    if(typeof(updateValue)=='number');
    {
      if(updateChildDetails.findIndex(item=>item.TransTypeId===22)!==-1)
      {
        updateChildDetails.find(item=>item.TransTypeId===22).TransAmount = updateValue;
      }
      else 
      {
        const newLoadFee={
            "TransId": 0,
            "TransTypeId": 22,
            "TransTypeName": "Fee",
            "AssetId": transactionData?.AssetId,
            "ShareclassId": 30867,
            "AssetLotId": transactionData.AssetLotId,
            "TransDate": transactionData.TransDate,
            "TransAmount": updateValue,
            "InitialAllocationDate": null,
            "TotalNrOfShares": null,
            "TotalPosition": null,
            "TransPercentage": null,
            "NrOfShares": 0,
            "TransDescription": "Fee row",
            "ModifiedById": 0,
        };
        updateChildDetails.push(newLoadFee)
      }
      // const localAmt=(parseFloat(transAmt) + updateValue) * parseFloat(exchangeRate) || 0;
      setTransactionData((prevData) => ({ ...prevData, ChildDetails: updateChildDetails }));
    }
   

  };
  const closeModal = () => {
    setShowModal(false);
}
const handleClick = () => {
  setShowModal(true);
 
};
  return (
    <>
      <TopBar label={"Transactions"} />
      <div id="TransactionList" className="mainContentData">
        <BreadCrumbs Levels={Level} />
        <div className="container-fluid p-3">
          <div className="detail p-4">
            <div className="row">
              <div className="row mb-4">
              <div className="col-md-4">
                  <label className="mb-1 label">Status</label>
                  <div>
                    <SBADropDown
                      className="w-75"
                      data={StatusStore}
                      textField={"TransStatus"}
                      valueField={"TransStatusId"}
                      value={statusValue}
                      onChange={(e) => updateStatus(e)}
                      disabled={transactionId !== 0}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <label className="mb-1 label">Portfolio <span class="mandatory">*</span> </label>
                  <div>
                    <SBAComboBox
                      className="w-75"
                      data={portfolioList}
                      textField={"PortfolioName"}
                      valueField={"PortfolioId"}
                      value={portfolioValue}
                      onChange={(e) => updatePortfolio(e)}
                      onFilterChange={portfolioFilterChange}
                      disabled={transactionId !== 0}
                    />
                  </div>
                </div>
              </div>
              <div className="row mb-4">
              <div className="col-md-4">
                  <label className="mb-1 label">From Account <span class="mandatory">*</span></label>
                  <div>
                    <SBADropDown
                      className="w-75"
                      data={fromAccountDS}
                      textField={"AssetName"}
                      valueField={"AssetId"}
                      value={fromAccountValue}
                      onChange={(e) => updateFromAccount(e)}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <label className="mb-1 label">Asset <span class="mandatory">*</span></label>
                  <div>
                    <SBAComboBox
                      className="w-75"
                      data={assetList}
                      textField={"AssetName"}
                      valueField={"AssetId"}
                      value={assetValue}
                      onChange={(e) => updateAsset(e)}
                      onFilterChange={AssetFilterChange}
                      disabled={transactionId !== 0 }
                    />
                  </div>
                </div>
              </div>
              <div className="row mb-4">
              <div className="col-md-4">
                  <label className="mb-1 label">Share Class<span class="mandatory">*</span> </label>
                  <div>
                    <SBADropDown
                      className="w-75"
                      data={shareClassList}
                      textField={"ShareClassName"}
                      valueField={"ShareClassId"}
                      value={shareClassValue}
                      onChange={(e) => updateShareClass(e)}
                      disabled={transactionId!==0}
                    />
                  </div>
                  </div>
                  <div className="col-md-4">
                  <label className="mb-1 label">Lot<span class="mandatory">*</span> </label>
                  <div>
                    {/* <SBAComboBox
                      className="w-75"
                      data={assetLots}
                      textField={"AssetLotName"}
                      valueField={"AssetLotId"}
                      value={lotValue}
                      onChange={(e) => updateAssetLot(e)}
                      disabled={true}
                    />
                    <label className="fas fa-plus mx-3" onClick={() => openCreatAssetLot()}></label> */}
                     <input type="text" className="form-control w-75" value={lotName} disabled />
                  </div>
                  </div>
               </div>
               <div className="row mb-4">
               <div className="col-md-4">
                  <input
                    type="checkbox"
                    checked={isShareBased}
                    onChange={() => setIsShareBased(!isShareBased)}
                    disabled={assetLots.length === 0? false: true}
                  />
                  <label className="mb-1 mx-2 label">
                    Share Based</label>
                </div>
                </div>
                {isShareBased &&
                  <div className="row mb-4">
                <div className="col-md-4">
              
                 
                    <label className="mb-1 label">Shares  <span className="mandatory">*</span> </label>
                    <div className="d-flex gap-2">
                      <SBACurrencyInput
                        className="w-75"
                        decimalsLimit={2}
                        value={sharesCount?.toFixed(2)}
                        onBlur={(e) => { updateShares(e) }}
                      />
                   
                  </div>
                  </div>
                  <div className="col-md-4">
              
                  <label className="mb-1 label">NAV  <span className="mandatory">*</span> </label>
                    <div className="d-flex gap-2">
                      <SBACurrencyInput
                        className="w-75"
                        decimalsLimit={2}
                        value={navValue?.toFixed(2)}
                        onBlur={(e) => { updateNav(e) }}
                      />
                  </div>
                  </div>
                  </div>
                  }
                     <div className="row mb-4">
             
                </div>
                <div className="row mb-4">
                <div className="col-md-4">
                <label className="mb-1 label">Transaction Date   <span class="mandatory">*</span> </label>
                  <div className="d-flex gap-2">
                    <SBDatePicker
                      className="w-75"
                      value={moment(transDate)}
                      onChange={(e) => updateTransDate(e)}
                    />
                  </div>
                
                </div>

                <div className="col-md-4">
                                  <div> <Link className="noUnderLine" onClick={handleClick}>USD</Link></div>
                  <label className="mb-1 label">Amount  <span className="mandatory">*</span> </label>
                  <div className="d-flex gap-2">
                    <SBACurrencyInput
                      className="w-75"
                      decimalsLimit={2}
                      value={transAmt?.toFixed(2)}
                      onBlur={(e) => { udpateTransAmt(e) }}
                      disabled={isShareBased}
                    />
                    
                  </div>
                </div>
                <div className="col-md-4">
                                  <div><Link className="noUnderLine" onClick={handleClick}>{portfolio?.CurrencyCode}</Link><span style={{marginLeft:'8px'}}>({currencyFormatter(transactionData.ExchangeRate,2)})</span></div>
                <label className="mb-1 label">Local Amount  <span className="mandatory">*</span> </label>
                  <div className="d-flex gap-2">
                    <SBACurrencyInput
                      className="w-75"
                      decimalsLimit={2}
                      value={localAmount?.toFixed(2)}
                      disabled={true}
                    />
                  
                  </div>
                  </div>
                  </div>
                  <div className="row mb-4">
                  <div className="col-md-4">
                <label className="mb-1 label">Initial Allocation Date <span class="mandatory">*</span> </label>

<div className="d-flex gap-2">
  <SBDatePicker
    className="w-75"
    value={ moment(transDate) }
    onChange={(e) => updateInitialAllocationDate(e)}
    disabled={transactionId!==0}
  />
</div>
</div>
                <div className="col-md-4">
                <label className="mb-1 label">Fees   </label>
                  <div className="d-flex gap-2">
                    <SBACurrencyInput
                      className="w-75"
                      decimalsLimit={2}
                      value={loadFee?.toFixed(2)}
                      onBlur={(e) => { updateLoadFee(e) }}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                <label className="mb-1 label">  Fees  </label>
                  <div className="d-flex gap-2">
                    <SBACurrencyInput
                      className="w-75"
                      decimalsLimit={2}
                      value={localLoadFee?.toFixed(2)}
                     disabled={true}
                    />
                 </div>
                  </div>
                </div>
                <div className="row mb-4">
                <div className="col-md-4"></div>
<div className="col-md-4">
                <label className="mb-1 label">Total Amount<span className="mandatory">*</span> </label>
                  <div className="d-flex gap-2">
                    <SBACurrencyInput
                      className="w-75"
                      decimalsLimit={2}
                      value={totalTransAmt}
                     disabled={true}
                    />
                  </div>
</div>
<div className="col-md-4">
                <label className="mb-1 label">Total Local Amount<span className="mandatory">*</span> </label>
                  <div className="d-flex gap-2">
                    <SBACurrencyInput
                      className="w-75"
                      decimalsLimit={2}
                      value={totalLocalAmt}
                     disabled={true}
                    />
                  </div>
                  </div>
                  </div>

                  <label className="mb-1 label">Description</label>
              <div>
                <textarea
                  className="form-control"
                  type="text"
                  name="TransDescription"
                  onChange={(e) => updatedescription(e)}
                  defaultValue={description}
                />
              </div>
              <div
                className="m-3 d-flex justify-content-end pe-4"
              >
                <button className="s-sm-btn"
                  onClick={() => { navigateBack() }}
                >
                  Cancel
                </button>


                              {transactionId !== 0 ? (
                                  <button className="ms-2 p-sm-btn" disabled={!transactionEditAccess || transactionData.IsLocked} onClick={saveAllocation}>
                                      Save
                                  </button>
                              ) : (
                                      <button className="ms-2 p-sm-btn" disabled={false} onClick={saveAllocation}>
                                      Save
                                  </button>
                              )}

                

              </div>
                </div>
                </div>
                </div>
            
             
            </div>
         

            <ExchangeRateModal showModal={showModal} value={transactionData?.ExchangeRate} closeModal={()=>{setShowModal(false)}} onBlur={(e)=>exchangeRateChange(e)}></ExchangeRateModal>
      <CreateAssetLot open={createLot} setOpen={setCreateLot} saveLot={saveAssetLot} existingLot={assetLots} />
      <AllocationdateConfrimationModal open={null} setOpen={null} updateInitialAllocationDate={null} />
      <ToastContainer />
    </>
  );
};


const CreateAssetLot = ({ open, setOpen, saveLot , existingLot  }) => {
  const [lotAllocationDate, setLotAllocationDate] = useState(transactionDate);
  const [lotTransactionDate, setLotTransactionDate] = useState(transactionDate);
  const [isShareBased, setIsShareBased] = useState(false);
  useEffect(()=>{
    if(existingLot.length>0)
    setIsShareBased(existingLot[0].IsShareBased);
  },[existingLot])
  const updateDate = (e, setter) => {
    if (e) {
      const updatedDate = e.toISOString();
      setter(updatedDate);
    }
  }
  return <SBADrawer open={open} setOpen={setOpen} close={false} title={'Create Asset Lot'}>
    <div>
      <label className="header-container m-1"><b>Init Allocation Date</b></label>
      <div>
        <SBDatePicker
          popupSettings={{ className: 'modalDD' }}
          className="w-75"
          value={moment(lotAllocationDate)}
          onChange={(e) => { updateDate(e, setLotAllocationDate) }}>
        </SBDatePicker>
      </div>
      <br></br>
      <label className="header-container m-1"><b>Transaction Date </b></label>
      <div>
        <SBDatePicker popupSettings={{ className: 'modalDD' }} className="w-75" value={moment(lotTransactionDate)} onChange={(e) => { updateDate(e, setLotTransactionDate) }}>
        </SBDatePicker>
      </div>
      <br></br>
      <div className="mb-4">
        <label className="mb-1 label">  <input type="checkbox" checked={isShareBased} onChange={(e) => { setIsShareBased(e.target.checked) }} disabled={existingLot.length>0} /> Is Share Based</label>
      </div>
      <div className="mt-4">
        <button className="s-sm-btn mx-1" onClick={() => setOpen(false)}>
          Cancel
        </button>
       
        <button className="p-sm-btn mx-1" onClick={() => { saveLot(lotAllocationDate, lotTransactionDate, isShareBased) }}>
          Save
        </button>

      </div>
    </div>
  </SBADrawer>
};
const AllocationdateConfrimationModal = ({ open, setOpen, udpateAllocationDate }) => {
  return <Modal show={open}>
    <Modal.Header
      closeButton
      onClick={() => {
        setOpen(false);
      }}
    >
      <Modal.Title>
        Initial Allocation Date
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>Initial Allocation Date is not equal to Transaction Date. Do you want to proceed?</p>
    </Modal.Body>
    <Modal.Footer>
      <button
        className="s-sm-btn mx-1"
        onClick={udpateAllocationDate}
      >
        Cancel
      </button>
      <button
        className="p-sm-btn mx-1"
        onClick={() => { setOpen(false) }}
      >
        Yes
      </button>
    </Modal.Footer>
  </Modal>
};


function convertToISO(input) {
  let dateMoment;

  if (moment.isMoment(input)) {
      dateMoment = input;
  } else if (typeof input === 'string') {
      dateMoment = moment(input, "DD-MM-YYYY", true);
      
      if (!dateMoment.isValid()) {
          dateMoment = moment(input);
      }
  } else if (input instanceof Date) {
      dateMoment = moment(input);
  } else {
      throw new Error("Unsupported input format");
  }
  if (!dateMoment.isValid()) {
      throw new Error("Invalid date format");
  }

  return dateMoment.toISOString();
}